@if (candidate) {
  <div class="candidate-actions" [class.revealed]="revealed">
    @if (actionsInfo$ | async; as actionsInfo) {
      <div class="candidate-actions__wrapper">
        <app-locked-action
          class="candidate-action candidate-action-line"
          [locked]="(isLimited$ | async) ?? false">
          <div
            class="btn btn--icon"
            [class.disabled]="(isAddToFolderStartedInfo$ | async).condition"
            (click)="onFolderAction()">
            <svg class="icon btn__icon" width="16" height="16">
              <use xlink:href="#medium-folder"></use>
            </svg>
            <span class="btn__text" [class.minus]="type === 'forFolder'">
              @if (type === 'standard' && actionsInfo.foldersCount) {
                {{ actionsInfo.foldersCount }}
              }
            </span>
          </div>
        </app-locked-action>
        <div class="candidate-action">
          <app-profile-export-actions
            class="export-actions-wrapper"
            [profile]="candidate"
            [actionsInfo]="actionsInfo"
            [image]="picture"
            [isFullProfile]="false"
            [forSearchPage]="type === 'standard'"
            [columnStyle]="true"
            [folderId]="folderId"
            (profileAddedToCampaign)="onProfileAddedToCampaign()"></app-profile-export-actions>
        </div>
        <div class="candidate-action candidate-action-line">
          @if (contextMenuItems$ | async; as menuItems) {
            <app-common-actions-menu
              class="flex"
              [items]="menuItems"
              [totalCount]="contextMenuTotalCount"
              (actionClicked)="onContextMenuAction($event)"></app-common-actions-menu>
          }
        </div>
      </div>
    }
  </div>
}
